import React, { useState } from "react";
import FilterBar from "./FilterBar";
import MatchDayBlock from "./MatchDayBlock";
import InfiniteScroll from "../../InfiniteScroll";
import "../styles/MatchDaysList.css";
import { useSelector, useDispatch } from "react-redux";
import { matchDayFormShow } from "../redux/actions";
import MatchDayForm from "./MatchDayForm";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";

export default function MatchDaysList() {
    const dispatch = useDispatch();
    const [filteredDays, setFilteredDays] = useState([]);
    const showForm = useSelector((state) => state.leagueReducer.showForm);
    const { t } = useTranslation();

    const renderList = () => {
        if (Array.isArray(filteredDays)) {
            const elements = filteredDays.map((matchDay, index) => (
                <MatchDayBlock
                    key={matchDay?.matchDayKey}
                    matchDay={matchDay}
                />
            ));
            return (
                <InfiniteScroll
                    array={elements}
                    step={5}
                    wrapperClass="matchdays-block-wrap"
                />
            );
        } else {
            return null;
        }
    };

    return (
        <div className="matchdays-list-wrap">
            <div className="matchdays-list-header">
                <div className="matchdays-list-filter">
                    <span className="matchdays-list-label">
                        {t("gamedays.matchday_list.title")}
                    </span>
                    <FilterBar setFilteredDays={setFilteredDays} />
                </div>
                <Button
                    variant="outlined"
                    color="success"
                    onClick={() => dispatch(matchDayFormShow(true))}
                >
                    {`+ ${t("gamedays.matchday_list.add_matchday_btn")}`}
                </Button>
            </div>
            {showForm && <MatchDayForm />}
            {renderList()}
        </div>
    );
}
